import GfcrIndicatorSetNav from './GfcrIndicatorSetNav'

export default GfcrIndicatorSetNav
